import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  redmineUser: null,
  project: null
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/store/index.js